import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BricknBarLogo from "../../assets/HomeImages/bnbfooter.webp";
import { Mail, Phone, MapPin } from "lucide-react";
import TopBar from "./Footer/TopBar";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import { FaCcVisa, FaCcMastercard, FaCcApplePay, FaLock } from "react-icons/fa";
import { SiDiscover } from "react-icons/si";
import { useAuth } from "../../utils/AuthContext ";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";
import footerbg from "../../assets/HomeImages/Footer.webp";
import FooterLinksAndPayments from "./Footer/FooterLinksAndPayments";
import ReturnAndExchangePolicy from "../Home/ReturnAndExchangePolicy";

const Footer = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/categories/get-all-categories`
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setCategories(data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch categories");
        setLoading(false);
        console.error(err);
      }
    };

    fetchCategories();
  }, []);

  const handleProtectedNavigation = (route) => {
    if (user) {
      navigate(route);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/sign-in");
    }
  };

  const handlePublicNavigation = (route) => {
    navigate(route);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCategoryClick = (categoryId) => {
    navigate(`/allcategories/${categoryId}`);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <footer
        className=" text-black relative bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${footerbg})`,
        }}
      >
        <TopBar />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-6 lg:gap-8">
            {/* Company Info Section */}
            <div className="text-white rounded-lg lg:col-span-4 sm:col-span-2 pb-0 sm:pb-3">
              <Link to="/" className="inline-block mb-4 sm:mb-6">
                <img
                  src={BricknBarLogo}
                  alt="BricknBar Logo"
                  className="h-16 sm:h-20 lg:h-24 w-auto max-w-full"
                />
              </Link>

              <div className="space-y-3 sm:space-y-4 text-sm sm:text-base">
                <div className="flex items-start">
                  <FiPhone
                    className="text-orange-400 mt-1 mr-3 flex-shrink-0"
                    size={16}
                  />
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm">
                      Feel Free to Call us
                    </p>
                    <p className="text-white font-medium">+91 (9777) 772-782</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FiMail
                    className="text-orange-400 mt-1 mr-3 flex-shrink-0"
                    size={16}
                  />
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm">
                      For any inquiries mail us at
                    </p>
                    <p className="text-white font-medium break-all">
                      bricknbar1@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <FiMapPin
                    className="text-orange-400 mt-1 mr-3 flex-shrink-0"
                    size={16}
                  />
                  <div>
                    <p className="text-gray-400 text-xs sm:text-sm">
                      Please Visit Us
                    </p>
                    <p className="text-white font-medium text-sm sm:text-base">
                      BricknBar,Plot no-769
                      <br />
                      Kalinga Vihar,Bhubaneswar, Odisha-751019
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Categories Section */}
            <div className="lg:col-span-3 sm:col-span-1">
              <h4 className="font-bold text-base sm:text-lg relative text-white mb-4 sm:mb-6">
                <span className="after:content-[''] after:absolute after:w-12 sm:after:w-16 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                  Categories
                </span>
              </h4>

              <div className="mt-6">
                {loading ? (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 sm:gap-y-4 gap-x-4 sm:gap-x-8">
                    {[...Array(10)].map((_, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <div className="w-3 h-3 bg-gray-200 rounded-full animate-pulse"></div>
                        <div className="h-4 bg-gray-200 rounded animate-pulse flex-1"></div>
                      </div>
                    ))}
                  </div>
                ) : error ? (
                  <div className="text-red-500 text-sm">{error}</div>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 sm:gap-x-8">
                    {[0, 1].map((col) => (
                      <div key={col} className="space-y-3 sm:space-y-4">
                        {categories
                          .slice(col * 5, (col + 1) * 5)
                          .map((category) => (
                            <div
                              key={category._id}
                              onClick={() => handleCategoryClick(category._id)}
                              className="flex items-center cursor-pointer group"
                            >
                              <span className="text-orange-300 mr-2">›</span>
                              <span className="text-gray-300 group-hover:text-orange-400 transition duration-300 text-sm sm:text-base">
                                {category.name}
                              </span>
                            </div>
                          ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* Others/Policies Section */}
            <div className="lg:col-span-2 sm:col-span-1">
              <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6 relative text-white">
                <span className="after:content-[''] after:absolute after:w-6 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                  Others
                </span>
              </h4>
              <ul className="mt-6 space-y-2 sm:space-y-3">
                {[
                  {
                    label: "Exchange Policy",
                    route: "/return-and-exchange-policy",
                  },
                  {
                    label: "Refund Policy",
                    route: "/return-and-exchange-policy",
                  },
                  {
                    label: "Term & Conditions",
                    route: "/terms-and-condition",
                  },
                  { label: "Privacy Policy", route: "/privacy" },
                  {
                    label: "Shipment Policy",
                    route: "/return-and-exchange-policy",
                  },
                ].map((item, index) => (
                  <li key={index}>
                    <span
                      onClick={() => handleProtectedNavigation(item.route)}
                      className="text-gray-300 hover:text-orange-400 transition duration-300 flex items-center cursor-pointer text-sm sm:text-base"
                    >
                      <span className="mr-2 text-orange-300">›</span>{" "}
                      {item.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Display Houses Section */}
            <div className="lg:col-span-3 sm:col-span-2">
              <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6 relative text-white">
                <span className="after:content-[''] after:absolute after:w-12 sm:after:w-14 after:h-1 after:bg-orange-500 after:left-0 after:-bottom-2">
                  Our Display House
                </span>
              </h4>
              <ul className="mt-6 space-y-2 sm:space-y-3">
                {[
                  "Kalinga Vihar",
                  "Jaydev Vihar",
                  "Master canteen",
                  "Patia",
                ].map((place, index) => (
                  <li
                    key={index}
                    className="text-gray-300 hover:text-orange-400 transition duration-300 cursor-pointer text-sm sm:text-base"
                  >
                    <span className="mr-2 text-orange-300">›</span>
                    {place}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </footer>
      <FooterLinksAndPayments />
      <ReturnAndExchangePolicy />
    </>
  );
};

export default Footer;
